import { render, staticRenderFns } from "./AlumnoCursadoForm.vue?vue&type=template&id=ea95d1a2&scoped=true&"
import script from "./AlumnoCursadoForm.vue?vue&type=script&lang=js&"
export * from "./AlumnoCursadoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea95d1a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
